/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_What_TitleInputs */

const tr_katalog_desi_page_what_title = /** @type {(inputs: Katalog_Desi_Page_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi nedir?`)
};

const en_katalog_desi_page_what_title = /** @type {(inputs: Katalog_Desi_Page_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is desi?`)
};

const de_katalog_desi_page_what_title = /** @type {(inputs: Katalog_Desi_Page_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist Desi?`)
};

const ru_katalog_desi_page_what_title = /** @type {(inputs: Katalog_Desi_Page_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что такое деси?`)
};

/**
* | output |
* | --- |
* | "What is desi?" |
*
* @param {Katalog_Desi_Page_What_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_what_title = /** @type {((inputs?: Katalog_Desi_Page_What_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_What_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_what_title(inputs)
	if (locale === "de") return de_katalog_desi_page_what_title(inputs)
	if (locale === "ru") return ru_katalog_desi_page_what_title(inputs)
	return tr_katalog_desi_page_what_title(inputs)
});